import * as React from "react";
import {CardConfig, WidgetCountData} from "../../../dashboard/widgets/standard/CountsWidget";
import {FilterCountCard} from "../../../dashboard/widgets/standard/components/FilterCountCard";
import {ACCESSES_COLOR, NOT_ACCESSES_COLOR} from "../../UserManagement";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {UsersAccessPerADay} from "../../../types/UsersManagementTypes";

declare var AppTranslations: AppTranslations;

interface CountDaysWithLoginProps {
    data: UsersAccessPerADay;
}

const LOGIN_CARDS_CONFIG: CardConfig[] = [{color: ACCESSES_COLOR}, {color: NOT_ACCESSES_COLOR}]

const getDaysWithLoginCard = (data: WidgetCountData[]): JSX.Element[] => {
    return data.map((value, index) =>
        <FilterCountCard
            title={value.title}
            value={value.count}
            total={value.total}
            defaultColor={LOGIN_CARDS_CONFIG[index].color}
            anticlockwise={LOGIN_CARDS_CONFIG[index].anticlockwise}
            reverseColors={false}
            noGreen={false}
            shortcutCode={value.shortcutCode}
            stackManager={null}
            key={index}
        />)
}

const getDaysWithLogin = (userAccessesByDayData: UsersAccessPerADay): WidgetCountData[] => {
    const totalDays: number = userAccessesByDayData.usersLogging.length;
    const numberOfLogin: number = userAccessesByDayData.usersLogging.filter(
        usersAccessInADay => usersAccessInADay.users === 1).length;

    return [
        {
            title: AppTranslations.usersManagement.daysWithUserActivity,
            count: numberOfLogin,
            total: totalDays,
            shortcutCode: "accesses"
        },
        {
            title: AppTranslations.usersManagement.daysWithoutUserActivity,
            count: totalDays - numberOfLogin,
            total: totalDays,
            shortcutCode: "not-accesses"
        },
    ]
}

export const CountDaysWithLogin: React.FC<CountDaysWithLoginProps> = ({data}) => {

    return <div className={"counts-widget"}>
        <div className={"list-widget__content"}>
            {getDaysWithLoginCard(getDaysWithLogin(data))}
        </div>
    </div>
}